import React from 'react';

/**
 * DashboardTile - Shared tile wrapper for all dashboard pages
 *
 * Props:
 *   title     - Tile header text
 *   icon      - Lucide icon component
 *   onClick   - Click handler (makes tile clickable)
 *   colSpan   - Grid column span (1-6, default 2)
 *   rowSpan   - Grid row span (default 1)
 *   legend    - Array of { color, label, value } for bottom legend
 *   className - Additional CSS class
 *   children  - Tile content
 */
const DashboardTile = ({ title, icon: Icon, onClick, colSpan = 2, rowSpan = 1, legend, className = '', children }) => {
  const style = {};
  if (colSpan !== 1) style.gridColumn = `span ${colSpan}`;
  if (rowSpan !== 1) style.gridRow = `span ${rowSpan}`;

  return (
    <div
      className={`dashboard-tile ${onClick ? 'clickable' : ''} ${className}`}
      style={style}
      onClick={onClick}
    >
      {(Icon || title) && (
        <div className="tile-header">
          {Icon && <Icon size={18} className="tile-icon" />}
          {title && <span className="tile-title">{title}</span>}
        </div>
      )}
      <div className="tile-content">
        {children}
      </div>
      {legend && legend.length > 0 && (
        <div className="tile-legend">
          {legend.map((item, i) => (
            <span key={i} className="legend-item">
              <span className="legend-dot" style={{ background: item.color }} />
              {item.label}: {item.value}
            </span>
          ))}
        </div>
      )}
    </div>
  );
};

export default DashboardTile;
